import i18n from "i18n";

export const ScheduleFrequencies = {
	Daily: "Daily",
	Weekly: "Weekly",
};

export const ScheduleFrequencyOptions = () => [
	{ value: ScheduleFrequencies.Daily, label: i18n.t("option.daily") },
	{ value: ScheduleFrequencies.Weekly, label: i18n.t("option.weekly") },
];
